import { DialogLauncher } from '@formstack/phoenix/components/DialogLauncher';

import { withResources } from '@/resources/resource-context';

import { IPresentationException } from '../../interface';
import { ErrorDialog as Base } from './ErrorDialog';

export const ErrorDialog = withResources(Base);

export function launchErrorDialog(error: IPresentationException) {
  const dialogOptions = {
    component: ErrorDialog,
    data: { error },
  };

  return DialogLauncher.open(dialogOptions);
}
